/**
 * @voltxampere/ui — 74HC132 quad Schmitt-trigger NAND variant (Sprint 43-7)
 *
 * Sprint 43 ADR-0064 introduced the Schmitt branch on the
 * `digital-gate` canonical type. 74HC132 is the 2-input NAND
 * sibling of 74HC14 with the same hysteresis thresholds.
 * The current Schmitt branch is single-input; an actual 2-input
 * Schmitt NAND must be modelled by chaining a standard NAND before
 * a Schmitt NOT in user circuits — full fused 2-input hysteresis
 * lands Sprint 50+ along with the broader smooth-threshold work.
 *
 * Reference: TI SN74HC132. V_T+ typ 1.7 V, V_T- typ 0.9 V at Vcc=5 V.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic74hc132 = {
    id: "74hc132",
    nameTr: "74HC132 (4'lü Schmitt NAND, DIP-14)",
    nameEn: "74HC132 (Quad Schmitt NAND, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "74HC132",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NAND",
        outputType: "schmitt",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        vThresholdPlus: 1.7,
        vThresholdMinus: 0.9,
        propagationDelay: 12e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-74hc132.js.map